


























import Vue from "vue";
export default Vue.extend({
  name: "Clusters",
  computed: {
    clusters(): Array<{
      id: number,
      lat: number,
      lng: number,
      conc : number
    }> {
      return [
        {
          id: 1,
          lat: 10,
          lng: 15,
          conc: 100,
        },
      ];
    },
    sortedClusters(): Array<{
      id: number,
      lat: number,
      lng: number,
      conc : number
    }> {
        let clusters = this.clusters;
        return clusters.sort((a,b) => a.conc - b.conc).slice(0,10);
    }
  }
});

